// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Nunito', 'Nunito Fallback'","fontStyle":"normal"},"className":"__className_eef148","variable":"__variable_eef148"};